import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
  ViewEncapsulation
} from '@angular/core';

export type ConfirmButtonsAlign = 'default' | 'center';
/**
 * The Confirm Buttons
 *
 * This component is the wrapper for confirm buttons
 */
@Component({
  selector: 'td-wb-confirm-buttons',
  templateUrl: 'confirm-buttons.component.html',
  styleUrls: ['confirm-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.td-wb-confirm-buttons]': 'true',
    '[class.td-wb-confirm-buttons--center]': 'alignCenter()'
  }
})
export class ConfirmButtonsComponent {
  readonly align: InputSignal<ConfirmButtonsAlign> = input<ConfirmButtonsAlign>('default');

  protected readonly alignCenter: Signal<boolean> = computed(() => this.align() === 'center');
}
